export const DELETE_OBJECT = 'DELETE_OBJECT';
export const CLEAR_OBJECT = 'CLEAR_OBJECT';

export function deleteObject(data) {
  return {
    type: DELETE_OBJECT,
    payload: data,
  }
}

export function clearObjectToDelete(data) {
  return {
    type: CLEAR_OBJECT,
    payload: data,
  }
}


// WEBPACK FOOTER //
// ./src/actions/objectToDelete/index.js